import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import Tag from "ui-components/molecules/tag/tag";
import { cn } from "../../../../services/common/className";
const columnHelper = createColumnHelper<any>();

const getFormattedDate = (date: string) => {
  if (!date) return "";
  return date.toUiDateFormat()
}

const getFormattedCapatlizedString = (rawString: string) => {
  if (!rawString) return rawString;
  return rawString.split(/[ ,|_]+/).map(ele => `${ele.slice(0, 1).toUpperCase()}${ele.slice(1).toLocaleLowerCase()}`).join(" ");
}

const getFormattedReviewProgress = (pending: number, accepted: number, rejected: number) => {
  let reviewProgress = 0;
  let totalAccessorials = pending + accepted + rejected;
  let reviewedAccessorials = accepted + rejected;
  if (totalAccessorials && totalAccessorials > 0 && reviewedAccessorials) {
    reviewProgress = Math.floor((reviewedAccessorials / totalAccessorials) * 100)
  }
  return (
    <div className="cell__review-porgress-bar__container">
      <span className="cell__review-porgress-bar__info">
        <span className="cell__review-porgress-bar__progress-percentage">{(pending && +pending > 0) ? `${pending} Pending` : ''}</span>
        <span className="cell__review-porgress-bar__progress">
          {reviewedAccessorials}/{totalAccessorials}
        </span>
      </span>
      <div className={"cell__review-porgress-bar__bar" + (reviewProgress === 100 ? " --completed" : "")}>
        <div style={{ width: reviewProgress + "%" }}></div>
      </div>
    </div>
  )
}

const getFormattedRealizedAmount = (acceptedAmount: number) => {
  return (acceptedAmount) ? <Tag mix={cn("cell__realized-amount")("amount")}>
    {acceptedAmount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    })}
  </Tag>
    : <Tag mix={cn("cell__realized-amount")("no-amount")}>
      --
    </Tag>
}

export const getAccessorialReviewTerminalPerformanceColumns = (
  isAggregateByDate: boolean,
  isAggregateByTerminal: boolean,
  isAggregateByAccessorial: boolean
) => [
    ...((!isAggregateByTerminal) ? [columnHelper.accessor("terminalName", {
      header: "Terminal",
      id: "terminalName",
      size: 90,
      cell: (cellProps: any) => (
        <div className="cell__terminal">
          {cellProps.row.original.terminalAirportcode} - {getFormattedCapatlizedString(cellProps.row.original.terminalName)} <span className="terminal--text-light">{cellProps.row.original.terminalNumber}</span>
        </div>
      )
    })] : []),
    ...((!isAggregateByDate) ? [columnHelper.accessor("dateAdded", {
      header: "Date",
      id: "dateAdded",
      size: 40,
      cell: (cellProps: any) => (
        <>
          {getFormattedDate(cellProps.row.original.dateAdded)}
        </>
      )
    })] : []),
    ...((!isAggregateByAccessorial) ? [columnHelper.accessor("accessorialName", {
      header: "Accessorial",
      id: "accessorialName",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {cellProps.row.original.accessorialName}
        </>
      )
    })] : []),
    columnHelper.accessor("operationsPending", {
      header: "Operations Review Process",
      id: "operationsPending",
      size: 110,
      cell: (cellProps: any) => (
        <>
          {getFormattedReviewProgress(+cellProps.row.original.operationsPending, +cellProps.row.original.operationsAccepted, +cellProps.row.original.operationsRejected)}
        </>
      )
    }),
    columnHelper.accessor("operationsAccepted", {
      header: "Operations Accepted",
      id: "operationsAccepted",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {cellProps.row.original.operationsAccepted}
        </>
      )
    }),
    columnHelper.accessor("operationsRejected", {
      header: "Operations Rejected",
      id: "operationsRejected",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {cellProps.row.original.operationsRejected}
        </>
      )
    }),
    columnHelper.accessor("billingPending", {
      header: "Billing Review Process",
      id: "billingPending",
      size: 110,
      cell: (cellProps: any) => (
        <>
          {getFormattedReviewProgress(+cellProps.row.original.billingPending, +cellProps.row.original.billingAccepted, +cellProps.row.original.billingRejected)}
        </>
      )
    }),
    columnHelper.accessor("billingAccepted", {
      header: "Billing Accepted",
      id: "billingAccepted",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {cellProps.row.original.billingAccepted}
        </>
      )
    }),
    columnHelper.accessor("billingRejected", {
      header: "Billing Rejected",
      id: "billingRejected",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {cellProps.row.original.billingRejected}
        </>
      )
    }),
    columnHelper.accessor("acceptedAmount", {
      header: "Realized Amount",
      id: "acceptedAmount",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {getFormattedRealizedAmount(+cellProps.row.original.acceptedAmount)}
        </>
      )
    })
  ];